import React from 'react';
import { Dot } from 'recharts';
const CircularDot = _ref => {
  let {
    cx,
    cy,
    color
  } = _ref;
  const radius = 4;
  return /*#__PURE__*/React.createElement(Dot, {
    cx: cx,
    cy: cy,
    r: radius,
    fill: color
  });
};
export default CircularDot;